import { render } from "./AssignmentDetail.vue?vue&type=template&id=009144ed&scoped=true"
import script from "./AssignmentDetail.vue?vue&type=script&lang=js"
export * from "./AssignmentDetail.vue?vue&type=script&lang=js"

import "./AssignmentDetail.vue?vue&type=style&index=0&id=009144ed&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-009144ed"]])

export default __exports__